import { Link } from 'react-router-dom';
import { mangaArticles } from '@/mocks/mangaArticles';

export default function HotMangaSection() {
  const hotManga = mangaArticles.slice(0, 6);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">精选高分漫画，不容错过</p>
          </div>
          <Link
            to="/category"
            className="text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotManga.map((manga) => (
            <Link
              key={manga.id}
              to={`/article/${manga.id}`}
              className="group"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={manga.coverImage}
                  alt={manga.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs font-semibold px-2 py-0.5 rounded-full">
                  {manga.rating}
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                {manga.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 truncate">{manga.author}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}